import { NumberInput } from '@mantine/core'
import { FormField } from '@percent/lemonade'

import type { OpportunityFormMaxAttendeesFieldProps } from './opportunity-form-max-attendees-field.types'

export function OpportunityFormMaxAttendeesField({
  value,
  onChange,
  onBlur,
  touched,
  error,
  forceReadOnly,

  label,
  placeholder,
  hint,
}: OpportunityFormMaxAttendeesFieldProps) {
  return (
    <FormField
      label={label}
      necessity="optional"
      status={touched && error ? 'danger' : 'default'}
      statusMessage={error}
      // The hint is rendered separately below so it stays visible alongside a validation error
      // (FormField's status message would otherwise replace the description).
      instructions={hint}
      data-testid="participantSpotsField"
      disabled={forceReadOnly}
    >
      <NumberInput
        style={{ width: '100%' }}
        name="participantSpots"
        min={1}
        step={1}
        hideControls
        placeholder={placeholder}
        value={value}
        onBlur={onBlur}
        onChange={(value) => {
          const numValue = typeof value === 'string' ? Number(value) : value
          onChange(numValue < 1 ? undefined : numValue)
        }}
        error={!!error && !!touched}
        disabled={forceReadOnly}
      />
    </FormField>
  )
}
